const Accordion = {
  baseStyle: {
    button: {
      color: '#3493FB',
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '20px',
      _hover: {
        color: '#337AB7',
      },
      _focus: {
        boxShadow: 'none',
      },
    },
    icon: {
      fontSize: '16px',
      marginRight: '5px',
    },
    container: {
      border: '0',
    },
  },
  defaultProps: {
    root: {
      allowToggle: true,
      allowMultiple: true,
    },
  },
};

export default Accordion;
